import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { setAccent, ToastProvider } from '@theonefamily/ui';
import { App } from './App';
import './app.css';

// Fleet accent: orange #f97316
setAccent('#f97316');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider>
      <BrowserRouter basename="/fleet">
        <App />
      </BrowserRouter>
    </ToastProvider>
  </StrictMode>,
);
